import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';
import { useParams } from 'react-router-dom';

import { UserRoleName } from '../../../services/identity/types/UserProfile';
import CreateConsultationFor from '../../PatientForms/CaseCreation/CreateConsultationFor';

const CreateConsultationForValidation = (): JSX.Element | null => {
  const _params = useParams();
  const roleName = ((_params.targetRole ?? _params.role) as string).toLowerCase();
  const user: AuthState = useAppSelector(selectAuth);

  if (!user.userInfo) {
    window.location.replace('/');
    return null;
  }

  let component: JSX.Element;

  switch (roleName) {
    case UserRoleName.Patient.toLowerCase():
    case UserRoleName.Dependent.toLowerCase():
      if (
        user.userInfo?.role.name === UserRoleName.Admin ||
        user.userInfo?.role.name === UserRoleName.SuperAdmin ||
        user.userInfo?.role.name === UserRoleName.OrganizationAdmin ||
        user.userInfo?.role.name === UserRoleName.Collector ||
        user.userInfo?.role.name === UserRoleName.CareAdvisor
      ) {
        component = <CreateConsultationFor />;
        break;
      } else {
        component = <NotFoundPage />;
        break;
      }
    default:
      component = <NotFoundPage />;
      break;
  }
  return <div>{component}</div>;
};
export default CreateConsultationForValidation;
